import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, FormGroup, FormControl, FormLabel, InputGroup, Table } from 'react-bootstrap';

import PropTypes from 'prop-types';

import { Dots } from 'react-activity';
import 'react-activity/dist/react-activity.css';


import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";



class ClaimView extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;
		
		this.uuid = this.app.guid();

		this.dataobject = null;

		this.bounty = null;
		this.claim = null;
		
		let title = '';
		let wanted = '';
		let answer = '';
		let amount = 0;
		let currency = {symbol: ''};
		let currentcard = null;
		let bountycard = null;
		let bountycard_balance_int = 0;
		let bountycard_balance_string = '';

		
		this.state = {
				title,
				wanted,
				answer,
				amount,
				currency,
				currentcard,
				bountycard,
				bountycard_balance_int,
				bountycard_balance_string,
				isBountyOwner: false,
				isClaimOwner: false,
				claimstatus: 0,
				claim_uuid: '',
				claimername: '',
				claimeremail: '',
				claimeraddress: '',
				loaded: false,
				registration_text: 'loading...',
				message_text: 'loading...',
				sharelinkmessage: 'loading...',
				sharelink: 'loading...',
				processinginfo: 'processing claim',
				processing: false
		}
	}

	
	// post render commit phase
	componentDidMount() {
		console.log('ClaimView.componentDidMount called');

		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
				
		mvcmodule.registerEventListener('on_refreshPage', this.uuid, this.onRefreshPage.bind(this));


		let registration_text = mvcmyquote.t('This claim has been registered.');
		
		let message_text = mvcmyquote.t('Claimer details:');
	
		let sharelinkmessage = mvcmyquote.t('Send this link to the issuer to complete this claim:');
		
		
		this.setState({registration_text, message_text, sharelinkmessage});

		this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}
	
	async checkNavigationState() {
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		let app_nav_state = this.app.getNavigationState();
		let app_nav_target = app_nav_state.target;
		
		// check wallet is unlocked
		let unlocked = await this.app.checkWalletUnlocked()
		.catch(err => {
		});

		if (!unlocked) {
			// we open the default device wallet
			let devicewallet = await this.app.openDeviceWallet()
			.catch(err => {
			});

			walletuuid = devicewallet.uuid;

			this.setState({isdevicewallet: true});

		}
		else {
			let isdevicewallet = await this.app.isDeviceWallet(walletuuid);

			this.setState({isdevicewallet});
		}
		
		if (app_nav_target && (app_nav_target.route == 'claim') && (app_nav_target.reached == false)) {
			var params = app_nav_target.params;
			var dataobj = params.dataobject;

			if (dataobj && (dataobj.type === 'claim') && (dataobj.treated !== true)) {
				this.dataobject = dataobj;

				let txhash = params.txhash;

				let currencyuuid = dataobj.currencyuuid;

				// we fetch the claim to get latest version
				let claim = await mvcmyquote.fetchClaim(rootsessionuuid, walletuuid, currencyuuid, txhash);
				this.claim = claim;

	
				let amount = claim.amount;

				let answer = claim.answer;
				let private_submission = claim.private_submission;

				// payment details
				let payingto =  await mvcmyquote.getClaimPayingToAddress(rootsessionuuid, walletuuid, claim);

				// time
				let registration_text = mvcmyquote.t('This claim has been registered on');

				registration_text += ' ' + mvcmodule.formatDate(claim.blocktime, 'YYYY-mm-dd HH:MM:SS') + '.';


				// claimer details
				let claimername_encrypted = claim.ownername;
				let claimeremail_encrypted = claim.owneremail;
				
				let claimername = mvcmodule.fitString(claimername_encrypted, 24);
				let claimeremail = mvcmodule.fitString(claimeremail_encrypted, 24);
				let claimeraddress = claim.owner;
	
				let currency = await mvcmyquote.getCurrencyFromUUID(rootsessionuuid, currencyuuid)
				.catch(err => {
					console.log('error in ClaimView.checkNavigationState: ' + err);
				});
	
				var sharelink =  await this.app.getShareLink(txhash, currency.uuid);

				// original bounty
				let bounty = await mvcmyquote.fetchBounty(rootsessionuuid, walletuuid, currencyuuid, claim.bounty);
				this.bounty = bounty;

				let title = bounty.title;
				let wanted = bounty.wanted;

				let currentcard = null;

				let isBountyOwner = false;
				let isClaimOwner = false;

				let bountycard = null;
				let bountycard_balance_int = 0;
				let bountycard_balance_string = '';

				// look if a wallet is open
				let unlocked = await this.app.checkWalletUnlocked()
				.catch(err => {
				});

				if (unlocked) {
					let currentwallet = await mvcmodule.getWalletInfo(rootsessionuuid, walletuuid);
					
					// is it the bounty owner and/or the claim own
					let decryptcard = await mvcmyquote.getWalletDecryptingCard(rootsessionuuid, walletuuid, claim.owner);
					if ( decryptcard) {
						isClaimOwner = true;

						claimername = mvcmyquote.t('You');
						claimeremail = currentwallet.owneremail;					
					}

					decryptcard = await mvcmyquote.getWalletDecryptingCard(rootsessionuuid, walletuuid, bounty.owner);
					if (decryptcard) {
						isBountyOwner = true;

						// get the bounty card
						let bountycardaddress = bounty.bounty_card_address;

						bountycard = await mvcmyquote.getCurrencyCardWithAddress(rootsessionuuid, walletuuid, currencyuuid, bountycardaddress)
						.catch(err => {
							console.log('error in BountyView.checkNavigationState: ' + err);
						});

						if (bountycard) {
							let pos = await mvcmyquote.getCurrencyPosition(rootsessionuuid, walletuuid, currencyuuid, bountycard.uuid);
					
							if (pos !== undefined) {
								bountycard_balance_int = await pos.toInteger();
								bountycard_balance_string = await mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, pos);
							}
			
						}								

						// we decrypt the claimer's details
						let claimer_rsa_publickey = claim.owner_rsa_publickey;

						let claimername_plain = await mvcmyquote.rsaDecryptString(rootsessionuuid, walletuuid, decryptcard.uuid, claimer_rsa_publickey, claimername_encrypted)
						.catch(err => {
							console.log('error in ClaimView.checkNavigationState: ' + err);
						});

						let claimeremail_plain = await mvcmyquote.rsaDecryptString(rootsessionuuid, walletuuid, decryptcard.uuid, claimer_rsa_publickey, claimeremail_encrypted)
						.catch(err => {
							console.log('error in ClaimView.checkNavigationState: ' + err);
						});
						
						claimername = (claimername_plain ? claimername_plain : claimername);
						claimeremail = (claimeremail_plain ? claimeremail_plain  : claimeremail);
						
						if (bounty.private_submission) {
							// we decrypt the answer
							let answer_encrypted  = answer;
							let answer_plain = await mvcmyquote.rsaDecryptString(rootsessionuuid, walletuuid, decryptcard.uuid, claimer_rsa_publickey, answer_encrypted)
							.catch(err => {
								console.log('error in ClaimView.checkNavigationState: ' + err);
							});

							answer = (answer_plain ? answer_plain : answer);
						}

					}

					// is there a main card
					currentcard = await this.app.openCurrencyCard(currencyuuid)
					.catch(err => {
						console.log('error in ClaimView.checkNavigationState: ' + err);
					});

					if (currentcard) {
						let pretradecard = await mvcmyquote.getPretradeCard(rootsessionuuid, walletuuid, currentcard.uuid, currencyuuid)
						.catch(err => {
							console.log('error in ClaimView.checkNavigationState: ' + err);
						});

						if (pretradecard) {

						}
					}
				}
	
				this.setState({title, wanted, private_submission, amount, currency,
					answer,
					currentcard, bountycard, bountycard_balance_int, bountycard_balance_string, 
					registration_text, sharelink, 
					isBountyOwner,
					isClaimOwner, 
					payingto, claimername, claimeremail, claimeraddress});

				dataobj.viewed = true;
			}

			// mark target as reached
			app_nav_target.reached = true;		
		}

		if (this.claim) {
			let claim = this.claim
			let claimstatus = claim.status; // 0 = unhandled, 1 = payment pending, 10 paid, -1 = rejection pending, -10 = rejected

			let claim_uuid = claim.uuid;

			let payment_txhash = claim.payment_txhash;

			this.setState({claim_uuid, claimstatus, payment_txhash});
		}

		this.setState({loaded: true});
	}

	async onRefreshPage() {
		console.log('ClaimView.onRefreshPage called');

		this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}
	
	// end of life
	componentWillUnmount() {
		let app = this.app;
		let mvcmodule = app.getMvcModuleObject();
		
		mvcmodule.unregisterEventListener('on_refreshPage', this.uuid);
	}
	
	// user actions
	async onShareLinkClick() {
		const {sharelink} = this.state;
		
		// create a textarea on the fly, then remove it to
		// be able to copy to clipboard
		var textArea = document.createElement("textarea");
		textArea.value = sharelink;

		document.body.appendChild(textArea);
		textArea.select();
		document.execCommand("Copy");
		textArea.remove();

		this.app.alert("Share link has been copied to clipboard");
	}
	
	async onAccept() {
		console.log('onAccept pressed!');

		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		let {currency, bountycard, isBountyOwner, payingto} = this.state;

		this.setState({processing: true});

		try {
			if (!isBountyOwner) {
				this.app.alert('Only original issuer can accept or reject a claim');
				this.setState({processing: false});
				return;
			}

			if (!bountycard) {
				this.app.alert('No bounty card to pay claim');
				this.setState({processing: false});
				return;
			}

			let txhash_org = this.claim.txhash;

			// re-fetch claim, modify and ask to update
			let claim = await mvcmyquote.fetchClaim(rootsessionuuid, walletuuid, currency.uuid, txhash_org)
			.catch(err => {
				console.log('error in ClaimListView.onAccept ' + err);
			});

			if (!claim)
				return Promise.reject('could not find claim for transaction hash ' + txhash_org);
	
			this.claim = claim;
			claim.status = 1;
			claim.ordId = (this.claim.ordId !== undefined ? this.claim.ordId + 1 : 1);

			// we get the pretrade card to save a transaction
			let pretradecard = await mvcmyquote.getPretradeCard(rootsessionuuid, walletuuid, bountycard.uuid, currency.uuid)
			.catch(err => {
				console.log('error in ClaimCreateForm.onAccept: ' + err);
			});
	
			if (!pretradecard) {
				this.app.alert('Could not get a card to register the claim');
				this.setState({processing: false});
				return;
			}
	
			// we top-up pretrade card to be sure being able to send a transaction
			const topupinfo = await mvcmodule.topUpCard(rootsessionuuid, walletuuid, pretradecard.uuid)		
			.catch(err => {
				console.log('error in ClaimCreateForm.onAccept: ' + err);
			});
	
			if ((!topupinfo) || (!topupinfo.top) ) {
				this.app.alert('Could not top up account to update claim. Wait a few seconds and try again.');
				this.setState({processing: false});
				return;
			}
			else{
				let transactioninfo = await mvcmyquote.getSchemeTransactionInfo(rootsessionuuid, pretradecard.schemeuuid);

				if (topupinfo.balance <= (transactioninfo ? transactioninfo.credits_threshold :  1)) {
					this.app.alert('Account has not been topped-up yet. Wait a few seconds and try again.');
					this.setState({processing: false});
					return;
				}
			} 

	
			// mark payment as pending
			var default_payingto_address = await mvcmyquote.getClaimPayingToAddress(rootsessionuuid, walletuuid, claim);

			if (payingto && (payingto != default_payingto_address)) {
				// if we specify a new address, we update the payingto field of the claim
				claim.payingto_overload = payingto;
				claim.payingto = await mvcmyquote.getClaimPayingToAddress(rootsessionuuid, walletuuid, claim);
			}

			let txhash_pending = await mvcmyquote.updateClaim(rootsessionuuid, walletuuid, pretradecard.uuid, claim)
			.catch(err => {
				console.log('error in ClaimCreateForm.onAccept: ' + err);
			});
	
			if (!txhash_pending) {
				this.app.alert('Could not mark claim payment as pending');
				this.setState({processing: false});
				return;
			}

			// perform payment
			let txhash_payment = await mvcmyquote.payClaim(rootsessionuuid, walletuuid, bountycard.uuid, claim)
			.catch(err => {
				console.log('error in ClaimCreateForm.onAccept: ' + err);
			});

			if (!txhash_payment) {
				this.app.alert('Could not pay claim');
				this.setState({processing: false});
				return;
			}


			// mark paid
			claim.status = 10;
			claim.ordId = (this.claim.ordId !== undefined ? this.claim.ordId + 1 : 1);
			claim.payment_txhash = txhash_payment;
	
			let txhash_paid = await mvcmyquote.updateClaim(rootsessionuuid, walletuuid, pretradecard.uuid, claim)
			.catch(err => {
				console.log('error in ClaimCreateForm.onAccept: ' + err);
			});
	
			if (!txhash_paid) {
				this.app.alert('Could not update the claim as paid');
				this.setState({processing: false});
				return;
			}

			this.setState({processing: false});

			this.app.refreshPage();	
		
			return true;
		}
		catch(e) {
			console.log('exception in onAccept: ' + e);
			this.setState({processing: false});
		}

	}

	async onReject() {
		console.log('onReject pressed!');

		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		let {currency, bountycard, isBountyOwner} = this.state;

		this.setState({processing: true});

		try {
			if (!isBountyOwner) {
				this.app.alert('Only original issuer can accept or reject a claim');
				this.setState({processing: false});
				return;
			}

			if (!bountycard) {
				this.app.alert('No bounty card to reject claim');
				this.setState({processing: false});
				return;
			}

			let txhash_org = this.claim.txhash;

			// re-fetch claim, modify and ask to update
			let claim = await mvcmyquote.fetchClaim(rootsessionuuid, walletuuid, currency.uuid, txhash_org)
			.catch(err => {
				console.log('error in ClaimListView.onAccept ' + err);
			});

			if (!claim)
				return Promise.reject('could not find claim for transaction hash ' + txhash_org);
	
			this.claim = claim;
			claim.ordId = (this.claim.ordId !== undefined ? this.claim.ordId + 1 : 1);
			claim.status = -10;
	
			// we get the pretrade card to save a transaction
			let pretradecard = await mvcmyquote.getPretradeCard(rootsessionuuid, walletuuid, bountycard.uuid, currency.uuid)
			.catch(err => {
				console.log('error in ClaimCreateForm.onAccept: ' + err);
			});
	
			if (!pretradecard) {
				this.app.alert('Could not get a card to register the claim');
				this.setState({processing: false});
				return;
			}
	
			// we top-up pretrade card to be sure being able to send a transaction
			const topupinfo = await mvcmodule.topUpCard(rootsessionuuid, walletuuid, pretradecard.uuid)		
			.catch(err => {
				console.log('error in ClaimCreateForm.onAccept: ' + err);
			});
	
			if ((!topupinfo) || (!topupinfo.top) ) {
				this.app.alert('Could not top up account to update claim. Wait a few seconds and try again.');
				this.setState({processing: false});
				return;
			}
			else{
				let transactioninfo = await mvcmyquote.getSchemeTransactionInfo(rootsessionuuid, pretradecard.schemeuuid);

				if (topupinfo.balance <= (transactioninfo ? transactioninfo.credits_threshold :  1)) {
					this.app.alert('Account has not been topped-up yet. Wait a few seconds and try again.');
					this.setState({processing: false});
					return;
				}
			} 
	
			let txhash_new = await mvcmyquote.updateClaim(rootsessionuuid, walletuuid, pretradecard.uuid, claim)
			.catch(err => {
				console.log('error in ClaimCreateForm.onAccept: ' + err);
			});
	
			if (!txhash_new) {
				this.app.alert('Could not update the claim');
				this.setState({processing: false});
				return;
			}

			this.setState({processing: false});

			this.app.refreshPage();	
		
			return true;
		}
		catch(e) {
			console.log('exception in onAccept: ' + e);
			this.setState({processing: false});
		}

	}

	// rendering
	renderClaimPart() {
		let { title, wanted, answer, amount, currency } = this.state;

		return (
			<div>
				<FormGroup controlId="title">
				<FormLabel>Bounty Title</FormLabel>
				<FormControl
					disabled
					autoFocus
					type="text"
					value={title}
					onChange={e => this.setState({title: e.target.value})}
				/>
				</FormGroup>

				<FormGroup controlId="wanted">
				<FormLabel>Wanted</FormLabel>
				<FormControl 
					disabled
					as="textarea" 
					rows="3" 
					autoFocus
					type="text"
					value={wanted}
					onChange={e => this.setState({wanted: e.target.value})}
				/>
				</FormGroup>

				<FormGroup controlId="answer">
				<FormLabel>Answer</FormLabel>
				<FormControl 
					disabled
					as="textarea" 
					rows="3" 
					autoFocus
					type="text"
					value={answer}
					onChange={e => this.setState({answer: e.target.value})}
				/>
				</FormGroup>

				<FormGroup className="Proposal" controlId="proposal">
				<span className="ProposalCol">
				<FormLabel>Amount</FormLabel>
				<FormControl 
					disabled
					autoFocus
					type="text"
					value={amount}
					onChange={e => this.setState({amount: e.target.value})}
				/>
				</span>
				<span className="ProposalCol">
				<FormLabel>Currency</FormLabel>
				<InputGroup>
					<FormControl 
						disabled
						autoFocus
						type="text"
						value={currency.symbol}
						onChange={e => this.onChangeCurrency(e)}
					/>
				</InputGroup>
				</span>
				</FormGroup>
			</div>
		);
	}

	renderAcceptRejectButtons() {
		let { loaded, claimstatus, isBountyOwner, bountycard_balance_int, payingto } = this.state;

		if (loaded) {
			if (isBountyOwner) {
				if (claimstatus != 0) {
					// can no longer process the claim
					switch(claimstatus) {
						case -10:
							return (<span> <div className="Separator"><span>Rejected</span></div></span>);
						case -1:
							return (<span> <div className="Separator"><span>Rejection Pending</span></div></span>);
						case 1:
							return (<span> <div className="Separator"><span>Acceptation Pending</span></div></span>);
						case 10:
							return (<span> <div className="Separator"><span>Accepted</span></div></span>);
						default:
							return (<span> <div className="Separator"><span>Unknown Status</span></div></span>);
					}
					
				}
				else {
					return (
						<span>
							<FormGroup controlId="payingto">
							<FormLabel>Paying to</FormLabel>
							<FormControl 
								type="text"
								value={payingto}
								onChange={e => this.setState({payingto: e.target.value})}
							/>
							</FormGroup>

							{(bountycard_balance_int ?
							<span className="AcceptReject">
							<Button className="AcceptReject" onClick={this.onAccept.bind(this)} type="submit">
								Accept & Pay
							</Button>
							<Button className="AcceptReject" onClick={this.onReject.bind(this)} type="submit">
								Reject
							</Button>
							</span> :
							<span className="AcceptReject">
							<Button className="AcceptReject" onClick={this.onReject.bind(this)} type="submit">
								Reject
							</Button>
							</span>)}
						</span>
		
					);
				} 
			}
			else {
				// display current status
				switch(claimstatus) {
					case -10:
						return (<span> <div className="Separator"><span>Rejected</span></div></span>);
					case -1:
						return (<span> <div className="Separator"><span>Rejection Pending</span></div></span>);
					case 1:
						return (<span> <div className="Separator"><span>Acceptation Pending</span></div></span>);
					case 0:
						return (<span> <div className="Separator"><span>Unhandled Yet</span></div></span>);
					case 10:
						return (<span> <div className="Separator"><span>Accepted</span></div></span>);
					default:
						return (<span> <div className="Separator"><span>Unknown Status</span></div></span>);
				}
			}
			
		}
		else {
			return(
				<div className="Separator"><span>loading...</span></div>
			);
		}

	}

	renderBottomInfoPart() {
		let { registration_text, claim_uuid, message_text, sharelinkmessage, sharelink, 
			isBountyOwner, 
			claimstatus, payment_txhash,
			claimername, claimeremail, claimeraddress, payingto } = this.state;

		if (isBountyOwner) {
			return (
				<div>
					<div className="TextBox">
						{registration_text}
						<div>Claim&nbsp;uuid:{claim_uuid}</div>
						{((claimstatus == 10) && (payment_txhash) ? <div>Payment&nbsp;tx:{payment_txhash}</div> : <></>)}
					</div>
					
					<div className="TextBox">
					{message_text}
					<Table responsive>
						<tbody className="ListItem" >
						<tr><td>Claimer Name: </td><td>{claimername}</td></tr>
						<tr><td>Claimer Email: </td><td>{claimeremail}</td></tr>
						<tr><td>Registration Address: </td><td>{claimeraddress}</td></tr>
						<tr><td>Paying Address: </td><td>{payingto}</td></tr>
						</tbody>
					</Table>
					</div>

	
	
				</div>
			);
		}
		else {
			return (
				<div>
					<div className="TextBox">
						{registration_text}
						<div>Claim&nbsp;uuid:{claim_uuid}</div>
						{((claimstatus == 10) && (payment_txhash) ? <div>Payment&nbsp;tx:{payment_txhash}</div> : <></>)}
					</div>
					
					<div className="TextBox">
					<div>{sharelinkmessage}</div>
						<div className="ShareBlock">
						<span className="ShareLink" onClick={this.onShareLinkClick.bind(this)}>{sharelink}</span>
						<span className="ShareIcon" onClick={this.onShareLinkClick.bind(this)}><FontAwesomeIcon icon={faCopy} /></span>
						</div>
					</div>
	
					<div className="TextBox">
					{message_text}
					<Table responsive>
						<tbody className="ListItem" >
						<tr><td>Claimer Name: </td><td>{claimername}</td></tr>
						<tr><td>Claimer Email: </td><td>{claimeremail}</td></tr>
						</tbody>
					</Table>
					</div>
	
	
				</div>
			);		}

	}

	renderClaimView() {

		return (
			<div className="Form">
				{this.renderClaimPart()}

				{this.renderAcceptRejectButtons()}

				{this.renderBottomInfoPart()}

			</div>
		  );
	}

	render() {
		let {processing} = this.state; 

		if (processing === true) {
			return (
				<div className="Splash">
					<div>{this.state.processinginfo}</div>
					<Dots />
				</div>
			);
		}

		return (
			<div className="Container">
				<div className="Title">Claim View</div>
				{ this.renderClaimView()}
			</div>
		  );
	}
	
}


// propTypes validation
ClaimView.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
	currentwalletuuid: PropTypes.string,
	iswalletlocked: PropTypes.bool,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		pending: state.login.pending,
		success: state.login.success,
		lasterror: state.login.error,
		currentwalletuuid: state.wallets.walletuuid,
		iswalletlocked: state.wallets.islocked,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}


export {ClaimView};
export default connect(mapStateToProps, mapDispatchToProps)(ClaimView);

